// Moved here to prevent cyclic reference when referencing these from other files

export function arrayToMap<T>(arr: T[], getKey: (x: T) => string) {
    const map: Record<string, T | undefined> = {}
    for (const item of arr) {
        map[getKey(item)] = item
    }
    return map
}

export function mapToArray<T>(map: Record<string, T | undefined>) {
    const arr: T[] = []
    for (const key of Object.getOwnPropertyNames(map)) {
        const value = map[key]
        if (!value) {
            continue
        }
        arr.push(value)
    }
    return arr
}

export function assertUnreachable(x: never): undefined {
    return undefined
}

export function fetchToJSON<T>(url: string, options: RequestInit): Promise<T> {
    return new Promise((resolve, reject) => {
        fetch(url, options)
            .then((response) => {
                if (response.ok) {
                    resolve(response.json())
                } else {
                    reject(response)
                }
            })
            .catch((err) => {
                reject(err)
            })
    })
}
